import {
  createContext,
  useContext,
  useEffect,
  useState,
} from "react";
import { Outlet } from "react-router-dom";
import { api } from "../services/api";
import { toast } from "react-toastify";

import { useAuth } from "./AuthContext";
import { IBalance } from "@/interfaces/BalanceType";

type AuthContextData = {
  balance: IBalance;
  refreshBalance: (userId: number) => Promise<void>;
  setPaymentModal: React.Dispatch<React.SetStateAction<boolean>>
  paymentModal: boolean
};



export const UserContext = createContext({} as AuthContextData);

export function UserProvider() {
  const { decodedToken } = useAuth();

  const [balance, setBalance] = useState<AuthContextData["balance"]>({balance: 0, pending_balance: 0});
  const [paymentModal, setPaymentModal] = useState(false)
  
  // Debug log para paymentModal
  useEffect(() => {
    console.log('🟡 UserContext - paymentModal mudou para:', paymentModal);
  }, [paymentModal]);

  const getBalance = async (userId: number) => {
    try {
      if(!decodedToken.isActive) {
        return;
      }
      if (userId) {
        const response = await api.get(`/user/balance/${userId}`);
        const amount = response.data.body

        if (amount) {
          setBalance(amount);
          return;
        }
        setBalance({balance: 0, pending_balance: 0})


      }
    } catch (e) {
      toast.error("Ocorreu um erro ao tentar buscar o seu saldo");
    }
  };

  useEffect(() => {
    getBalance(decodedToken.id);
  }, []);

  return (
    <UserContext.Provider
      value={{
        refreshBalance: getBalance,
        balance,
        setPaymentModal,
        paymentModal
      }}
    >
      <Outlet />
    </UserContext.Provider>
  );
}

export function UseUser() {
  const context = useContext(UserContext);

  if (!context) {
    throw new Error("useUser must be used within an UserProvider");
  }

  return context;
}
